/** Form field names — one entry per input. */
export enum IFieldNames {
  requestedLoan = "requestedLoan",
  reason = "reason",
  ssn = "ssn",
  email = "email",
  phoneNumber = "phoneNumber",
  mockData = "mockData",
}

/** Reason dropdown option. */
export interface IReasonOption {
  id: string;
  value: string;
  label: string;
}

/** Which control renders a field. */
export type FieldKind = "amount" | "select" | "ssn" | "phone" | "text" | "textarea";

/** Declarative field descriptor. */
export interface IFieldSpec {
  name: IFieldNames;
  kind: FieldKind;
  label: string;
  options?: IReasonOption[];
}
